import React from 'react'
import PropTypes from 'prop-types'

/* eslint react/no-danger : 0 */
function RatesTermsRibbon({ data }) {
  return (
    <section className="data-spotlight">
      <div className="data-spotlight__terms-box">
        {data.pairs.map(pair => (
          <div className="data-spotlight__content-box" key={pair.first}>
            <h2
              className="datapoints-sub"
              dangerouslySetInnerHTML={{ __html: pair.first.replace(/\s{0,1}{.+}/g, '') }}
            />
            <p className="datapoints--terms" dangerouslySetInnerHTML={{ __html: pair.second }} />
          </div>
        ))}
      </div>
      {data.disclaimer ? (
        <div className="container__inner">
          <p className="data-spotlight__text">{`${data.disclaimer.first} ${data.disclaimer.second}`}</p>
        </div>
      ) : null}
    </section>
  )
}

RatesTermsRibbon.propTypes = {
  data: PropTypes.object.isRequired
}

export default RatesTermsRibbon
